export default __webpack_public_path__ + "static/media/icon-servicos-gerais.c37ed357.svg";